module.exports = __webpack_public_path__ + "static/media/card-MasterCard-inactive.5cefe974.svg";